<div class="card-container">
  <div class="card-front">
    <img class="card-background" src="/assets/images/background_loyalty_card.webp" />
    <img class="card-logo" src="/assets/images/logo-rectangle.webp" />

    <div class="member-details">
      <span class="member-name">{{ name }}</span>

      <span class="card-number">{{ cardNumber | formatCardNumber }}</span>
    </div>
    <ngx-barcode6
      [bc-format]="'CODE128'"
      [bc-width]="2"
      [bc-height]="60"
      [bc-margin]="0"
      [bc-value]="cardNumber || ''"
      class="barcode-container"
    ></ngx-barcode6>
  </div>
</div>
